import React from 'react';
import { Box, Container, Divider, Grid, IconButton, Link, Stack, Typography } from '@mui/material';
import { Instagram, LinkedIn, Twitter } from '@mui/icons-material';

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        background: 'linear-gradient(180deg, #0e0e0e 0%, #050505 100%)',
        color: 'rgba(255,255,255,0.86)',
        pt: { xs: 8, md: 10 },
        pb: { xs: 6, md: 8 },
        mt: { xs: 10, md: 12 },
      }}
    >
      <Container>
        <Grid container spacing={{ xs: 6, md: 8 }}>
          <Grid item xs={12} md={5}>
            <Stack spacing={2}>
              <Typography variant="h6" fontWeight={700}>
                Crimson Club of Mexico
              </Typography>
              <Typography variant="body2" color="rgba(255,255,255,0.72)">
                Independent association of students and alumni collaborating to strengthen
                civic leadership, cultural exchange, and innovation across Mexico.
              </Typography>
            </Stack>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Stack spacing={1.5}>
              <Typography variant="subtitle2" sx={{ textTransform: 'uppercase', letterSpacing: 1.5 }}>
                Navigate
              </Typography>
              {['home', 'events', 'about-us'].map((slug) => (
                <Link
                  key={slug}
                  href={`#${slug}`}
                  underline="hover"
                  color="rgba(255,255,255,0.72)"
                  sx={{ fontWeight: 500 }}
                >
                  {slug
                    .replace('-', ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase())}
                </Link>
              ))}
            </Stack>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Stack spacing={2}>
              <Typography variant="subtitle2" sx={{ textTransform: 'uppercase', letterSpacing: 1.5 }}>
                Get in touch
              </Typography>
              <Typography variant="body2">
                <Link href="mailto:contact-us@crimsonclub.mx" color="inherit" underline="hover">
                  contact-us@crimsonclub.mx
                </Link>
              </Typography>
              <Stack direction="row" spacing={1}>
                <IconButton
                  aria-label="Instagram"
                  href="#"
                  sx={{ color: 'rgba(255,255,255,0.75)' }}
                >
                  <Instagram />
                </IconButton>
                <IconButton
                  aria-label="LinkedIn"
                  href="#"
                  sx={{ color: 'rgba(255,255,255,0.75)' }}
                >
                  <LinkedIn />
                </IconButton>
                <IconButton
                  aria-label="Twitter"
                  href="#"
                  sx={{ color: 'rgba(255,255,255,0.75)' }}
                >
                  <Twitter />
                </IconButton>
              </Stack>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: { xs: 6, md: 8 }, borderColor: 'rgba(255,255,255,0.08)' }} />

        <Typography
          variant="caption"
          sx={{ display: 'block', textAlign: 'center', color: 'rgba(255,255,255,0.54)' }}
        >
          (c) {new Date().getFullYear()} Crimson Club of Mexico - All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}
